module.exports = __webpack_public_path__ + "img/chevron-2.8c99ce23.jpg";